module.exports = {
  SET_ADDED_ITEMS: 'SET/ADDED_ITEMS',
  SET_CART_FETCHING: 'SET/CART_FETCHING',
  CART_ADD_ITEM_SUCCESS: 'CART/ADD_ITEM_SUCCESS',
  CART_ADD_ITEM_ERROR: 'CART/ADD_ITEM_ERROR',
  CART_UPDATE_ITEM_SUCCESS: 'CART/UPDATE_ITEM_SUCCESS',
  CART_DELETE_ITEM_SUCCESS: 'CART/DELETE_ITEM_SUCCESS',
  CART_UPDATE_ITEM_STOCK_SUCCESS: 'CART/UPDATE_ITEM_STOCK_SUCCESS',
};
